import dayjs from 'dayjs';
import { InvoiceHeader } from '../../../../common/Invoice/InvoiceHeader';
import A4ContentProvider from '../../../../common/utils/A4ContentProvider';

const ViewBillAdjust = ({ data }: { data: any }) => {
  return (
    <div>
      <A4ContentProvider>
        <div style={styles.page}>
          <InvoiceHeader />

          <div style={styles.infoRow}>
            <div style={styles.infoBox}>
              <h4 style={styles.infoTitle}>Adjustment Details</h4>
              {data?.op_created_date && (
                <p>
                  <strong>Date:</strong> {dayjs(data.op_created_date).format('DD-MM-YYYY')}
                </p>
              )}
              {data?.client_name && (
                <p>
                  <strong>Client Name:</strong> {data?.client_name || 'N/A'}
                </p>
              )}
              {data?.vendor_name && (
                <p>
                  <strong>Vendor Name:</strong> {data?.vendor_name || 'N/A'}
                </p>
              )}
              {data?.account_routing_no && (
                <p>
                  <strong>Account Routing No:</strong> {data?.account_routing_no || 'N/A'}
                </p>
              )}
              {data?.account_name && (
                <p>
                  <strong>Account Name:</strong> {data?.account_name || 'N/A'}
                </p>
              )}
            </div>
            <div style={styles.infoBox}>
              <h4 style={styles.infoTitle}>Other Details</h4>
              <p>
                <strong>Adjustment ID:</strong> {data.op_id || 'N/A'}
              </p>
              <p>
                <strong>Transaction Type:</strong> {data?.op_trxn_type || 'N/A'}
              </p>
            </div>
          </div>

          <table style={styles.table}>
            <thead>
              <tr style={styles.tableHeader}>
                <th style={styles.tableHeaderCell}>Description</th>
                <th
                  style={{
                    ...styles.tableHeaderCell,
                    textAlign: 'right',
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>{data.op_note}</td>
                <td
                  style={{
                    ...styles.tableCell,
                    textAlign: 'right',
                    color: data.op_trxn_type === 'DEBIT' ? 'red' : 'green',
                  }}
                >
                  {data.op_trxn_type === 'DEBIT' ? '' : ''}
                  {data.op_amount}
                </td>
              </tr>
              <tr style={styles.totalRow}>
                <td style={{ ...styles.tableCell, textAlign: 'right' }}>Total:</td>
                <td
                  style={{
                    ...styles.tableCell,
                    textAlign: 'right',
                    color: data.op_trxn_type === 'DEBIT' ? 'red' : 'green',
                  }}
                >
                  {data.op_trxn_type === 'DEBIT' ? '' : ''}
                  {data.op_amount}
                </td>
              </tr>
            </tbody>
          </table>

          <div style={styles.footer}>
            <div style={styles.signatureBox}>
              <p style={styles.signatureLine}>__________________________</p>
              <p>Authorized Signature</p>
              {data?.op_created_date && (
                <p style={styles.reference}>
                  <strong>Date:</strong> {dayjs(data.op_created_date).format('DD-MM-YYYY')}
                </p>
              )}
            </div>
          </div>
        </div>
      </A4ContentProvider>
    </div>
  );
};

const styles = {
  page: {
    padding: '40px',
    color: '#333',
    fontSize: '14px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: 1.5,
  },
  metaRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    flexWrap: 'wrap' as const,
  },
  metaColumn: {
    flex: 1,
    minWidth: '200px',
    marginBottom: '10px',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    marginTop: '20px',
    gap: '5px',
    flexWrap: 'wrap' as const,
  },
  infoBox: {
    flex: 1,
    minWidth: '250px',
    padding: '12px 16px',
    borderRadius: '6px',
    border: '1px solid #bfbfbf',
  },
  infoTitle: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '10px',
    borderBottom: '1px solid #e0e0e0',
    paddingBottom: '4px',
    color: '#444',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    margin: '20px 0 30px 0',
  },
  tableHeader: {
    backgroundColor: '#f2f2f2',
  },
  tableHeaderCell: {
    padding: '12px',
    border: '1px solid #ddd',
    textAlign: 'left' as const,
    fontWeight: 600,
  },
  tableCell: {
    padding: '12px',
    border: '1px solid #ddd',
    verticalAlign: 'top' as const,
  },
  totalRow: {
    fontWeight: 600,
    backgroundColor: '#f9f9f9',
  },
  footer: {
    marginTop: '40px',
    paddingTop: '20px',
  },
  signatureBox: {
    textAlign: 'right' as const,
    marginTop: '30px',
  },
  signatureLine: {
    marginTop: '40px',
    marginBottom: '4px',
  },
  reference: {
    marginTop: '10px',
    fontSize: '13px',
  },
};

export default ViewBillAdjust;
